import type {
  RemoteDiagnoseEvent,
  RescheduleRemoteDiagnoseEvent,
  UpdateRemoteDiagnoseEvent
} from '@/types/remote-diagnose'
import { formatPlate } from '@/utils/remote-diagnose'

export const createRemoteDiagnose = async (formData: RemoteDiagnoseEvent, url: string) => {
  if (!formData.client_email) {
    formData.client_email = 'info@tvsengineering.nl'
  }

  if (!formData.address_billing.address_line1) {
    formData.address_billing = formData.address_shipping
  }

  formData.vehicle_registration_number = formatPlate(formData.vehicle_registration_number)

  return fetch(`${url}/remote-diagnose`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const updateRemoteDiagnose = async (formData: UpdateRemoteDiagnoseEvent, url: string) => {
  return fetch(`${url}/remote-diagnose/set-date`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const getRemoteDiagnose = async (payment_id: string, url: string) => {
  return fetch(`${url}/remote-diagnose?payment_id=${payment_id}`)
    .then((res) => res.json())
    .then((res) => res)
}

export const getNotAvailableDays = async (url: string) => {
  return fetch(`${url}/remote-diagnose/not-available-days`)
    .then((res) => res.json())
    .then((res) => res)
}

export const rescheduleRemoteDiagnose = async (
  formData: RescheduleRemoteDiagnoseEvent,
  url: string
) => {
  return fetch(`${url}/remote-diagnose/reschedule-date`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const validatePaymentStatus = async (reference: string, url: string) => {
  return fetch(`${url}/validate-payment-status`,{
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({reference})
  })
    .then((res) => res.json())
    .then((res) => res)
}
